import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-confirmation-dialog',
  template: `
    <p-dialog 
      [(visible)]="visible" 
      [modal]="true"
      [style]="{width: '450px'}"
      [draggable]="false"
      [resizable]="false"
      [showHeader]="false"
      [contentStyle]="{'padding': '0'}"
      [baseZIndex]="1000">
      
      <div class="confirmation-dialog">
        <div class="dialog-header">
          <i class="pi pi-exclamation-triangle warning-icon"></i>
          <h2>{{title || 'Confirm Delete'}}</h2>
        </div>

        <div class="dialog-content">
          <p>{{message}}</p>
        </div>
        
        <div class="dialog-footer">
          <p-button 
            label="Cancel" 
            icon="pi pi-times" 
            (click)="onCancel()"
            styleClass="p-button-text">
          </p-button>
          <p-button 
            [label]="confirmButtonText || 'Delete'" 
            [icon]="confirmButtonText === 'Discard' ? 'pi pi-times' : 'pi pi-trash'"
            (click)="onConfirm()"
            styleClass="p-button-danger">
          </p-button>
        </div>
      </div>
    </p-dialog>
  `,
  styles: [`
    .confirmation-dialog {
      .dialog-header {
        background: #fee2e2;
        padding: 1.5rem;
        display: flex;
        align-items: center;
        gap: 1rem;
        
        .warning-icon {
          font-size: 2rem;
          color: #dc2626;
        }

        h2 {
          margin: 0;
          color: #991b1b;
          font-size: 1.25rem;
          font-weight: 600;
        }
      }

      .dialog-content {
        padding: 1.5rem;
        
        p {
          margin: 0;
          color: #374151;
          font-size: 1rem;
          line-height: 1.5;
        }
      }

      .dialog-footer {
        padding: 1rem 1.5rem;
        display: flex;
        justify-content: flex-end;
        gap: 0.75rem;
        background: #f9fafb;
        border-top: 1px solid #e5e7eb;

        :host ::ng-deep {
          .p-button-text {
            color: #6b7280;
            
            &:hover {
              background: #f3f4f6;
            }
          }

          .p-button-danger {
            background: #dc2626;
            border-color: #dc2626;

            &:hover {
              background: #b91c1c;
              border-color: #b91c1c;
            }
          }
        }
      }
    }
  `]
})
export class ConfirmationDialogComponent {
  @Input() visible: boolean = false;
  @Input() message: string = '';
  @Input() title: string = '';
  @Input() confirmButtonText: string = '';
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onConfirm() {
    this.confirm.emit();
    this.visible = false;
    this.visibleChange.emit(false);
  }

  onCancel() {
    this.cancel.emit();
    this.visible = false;
    this.visibleChange.emit(false);
  }
} 